module.exports = __webpack_public_path__ + "img/step23_a_remove_plastic_from_supports.f5bfd8be.png";